<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="360"
    height="6"
    viewBox="0 0 360 6"
    fill="none"
    class="menu-divider-line"
  >
<!-- eslint-disable max-len -->
    <path
      d="M-4.07696e-05 2.6665C-4.07696e-05 4.13926 1.19387 5.33317 2.66663 5.33317C4.13939 5.33317 5.33329 4.13926 5.33329 2.6665C5.33329 1.19374 4.13939 -0.00016284 2.66663 -0.00016284C1.19387 -0.00016284 -4.07696e-05 1.19374 -4.07696e-05 2.6665ZM358.667 3.1665C358.943 3.1665 359.167 2.94265 359.167 2.6665C359.167 2.39036 358.943 2.1665 358.667 2.1665V2.6665V3.1665ZM2.66663 2.6665V3.1665H358.667V2.6665V2.1665H2.66663V2.6665Z"
      fill="white"
    />
    <!-- eslint-enable max-len -->
  </svg>
</template>

<script>
export default {
  name: 'MenuDividerLine',
};
</script>

<style scoped>
.menu-divider-line {
  width: 356px;
  height: auto;
}
</style>
